import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Ghost from '../auth/Ghost.jsx';
import { AUTH_BASE } from '../../services/oidcService';
import { beginWebLogin } from '../../services/webOidc';
import './WebSignInPage.css';

/**
 * web.apiboo.com before sign-in (platform/webGate.js): the whole page is the
 * sign-in. "Continue" sends this tab to auth.apiboo.com (Authorization Code +
 * PKCE, services/webOidc) and the IdP brings it back to /auth/callback;
 * "Create account" is the IdP's own register page. The terms step
 * (onboarding) comes AFTER the first sign-in, inside the app.
 */
export default function WebSignInPage({ loading = false }) {
  const { t } = useTranslation();
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState(null);

  const signIn = useCallback(async () => {
    setError(null);
    setWaiting(true);
    try {
      await beginWebLogin();
    } catch (e) {
      setWaiting(false);
      setError(e?.message || t('web.signIn.failed'));
    }
  }, [t]);

  return (
    <div className="web-signin app-shell-bg" data-testid={loading ? 'web-boot' : 'web-sign-in'}>
      <div className="web-signin__card">
        <div className="web-signin__logo">
          <Ghost variant="classic" size={52} animated glow />
        </div>
        {loading ? (
          <p className="web-signin__text" role="status">{t('web.signIn.loading')}</p>
        ) : (
          <>
            <h1 className="web-signin__title">{t('web.signIn.title')}</h1>
            <p className="web-signin__text">{t('web.signIn.text')}</p>
            {error && <div className="web-signin__error" role="alert">{error}</div>}
            <button type="button" className="web-signin__btn web-signin__btn--primary" onClick={signIn} disabled={waiting}>
              {waiting ? t('web.signIn.opening') : t('web.signIn.continue')}
            </button>
            <a className="web-signin__btn" href={`${AUTH_BASE}/register`}>
              {t('web.signIn.register')}
            </a>
            <p className="web-signin__foot">
              <a href="https://apiboo.com/download" target="_blank" rel="noopener noreferrer">{t('web.signIn.desktop')}</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
